import React from 'react'
import {
    AppBar,
    Box,
    Container,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    Typography,
    TextareaAutosize,
    TextField
} from '@mui/material'
import './css/AddNewCustomer.css'
import { useState, useEffect } from 'react'
import axios from 'axios'
import api from "../config/backend"
import { Country, State, City } from 'country-state-city'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'

const AddNewCustomer = ({ setOpen, setCustomersUpdatedRefresh }) => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [customerType, setCustomerType] = useState("business")
    const [companyName, setCompanyName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [panCard, setPanCard] = useState('')
    const [portalAccess, setPortalAccess] = useState('')
    const [street, setStreet] = useState('')
    const [streetone, setStreetOne] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [zipcode, setZipcode] = useState('')
    const [remarks, setRemarks] = useState()
    const [tabValue, setTabValue] = useState(0)
    const [selectedSalutation, setSelectedSalutation] = useState('salutation')
    const [salutationInputOpen, setSalutationInputOpen] = useState(false)
    const salutationOptions = ["MR", "MS", "MRS", "DR", "MISS"]
    const [selectedCountry, setSelectedCountry] = useState('Afghanistan')
    const [countryInputOpen, setCountryInputOpen] = useState(false)
    const [countryOptions, setCountryOptions] = useState([])
    const [stateOptions, setStateOptions] = useState([])
    const [countryOptions1, setCountryOptions1] = useState([])
    const [stateOptions1, setStateOptions1] = useState([])
    const [selectedCountry1, setSelectedCountry1] = useState('country')
    const [countryInputOpen1, setCountryInputOpen1] = useState(false)
    const [selectedState, setSelectedState] = useState('state')
    const [selectedState1, setSelectedState1] = useState('state')
    const [selectedCurrency, setSelectedCurrency] = useState('currency')
    const [currencyInputOpen, setCurrencyInputOpen] = useState(false)
    const [currencyOptions, setCurrencyOptions] = useState([])
    const [currencySearch, setCurrencySearch] = useState("")
    const [customFields, setCustomFields] = useState([{ fieldname: "", value: "" }])

    const _crm__token = localStorage.getItem("_crm__token")

    const handleSalutationClick = (salutation) => {
        setSelectedSalutation(salutation)
        setSalutationInputOpen(false)
    }

    const handleCountryChange = (event) => {
        const selectedCountryName = event.target.value
        setSelectedCountry(selectedCountryName)
        console.log(selectedCountryName)


        const selectedCountry = Country.getAllCountries().find((country) => country.name === selectedCountryName)

        if (selectedCountry) {
            const selectedStates = State.getStatesOfCountry(selectedCountry.isoCode)
            console.log({ selectedStates })

            setStateOptions(selectedStates.map((state) => state.name))
            console.log(stateOptions)
        }
    }

    useEffect(() => {
        const countries = Country.getAllCountries().map((country) => country.name)
        setCountryOptions(countries)
    }, [])

    // Populate state options
    useEffect(() => {
        if (selectedCountry) {
            const selectedCountryData = Country.getAllCountries().find(item => item.name === selectedCountry)

            if (selectedCountryData) {
                const countryStates = State.getStatesOfCountry(selectedCountryData.isoCode)

                setStateOptions(countryStates.map((state) => state.name))
            }
        }
    }, [selectedCountry])

    // const handleCountryChange1 = (event) => {
    //     const selectedCountryName1 = event.target.value
    //     setSelectedCountry1(selectedCountryName1)
    //     console.log(selectedCountryName1)


    //     const selectedCountry1 = Country.getAllCountries().find((country) => country.name === selectedCountryName1)

    //     if (selectedCountry1) {
    //         const selectedStates1 = State.getStatesOfCountry(selectedCountry1.isoCode)
    //         console.log({ selectedStates1 })

    //         setStateOptions1(selectedStates1.map((state) => state.name))
    //         console.log(stateOptions1)
    //     }
    // }

    const handleCurrencyClick = (option) => {
        setSelectedCurrency(option._id)
        setCurrencyInputOpen(false)
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${api}/Accounting/fetch-currency`, { token: _crm__token })
                const { data } = response

                if (data.success) {
                    console.log('edede', currencyOptions)
                    setCurrencyOptions(data.currency)
                }
            }
            catch (error) {
                console.log(error)
            }
        }

        fetchData()
    }, [])

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const handleSubmit = async () => {
        try {
            const { data, status } = await axios.post(`${api}/Accounting/create-customer`, {
                token: _crm__token,
                salutation: selectedSalutation,
                firstname: firstName,
                lastname: lastName,
                customertype: customerType,
                companyname: companyName,
                email: email,
                phone: phone,
                pancard: panCard,
                currency: selectedCurrency,
                address: {
                    street: street,
                    streetone: streetone,
                    city: city,
                    state: selectedState,
                    zipcode: zipcode,
                },
                remarks: remarks,
                customfields: customFields
            })

            if (data.success) {
                setOpen(false)
                setCustomersUpdatedRefresh(prev => prev + 1)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const [age, setAge] = React.useState('')

    const handleChange = (event) => {
        setAge(event.target.value)
    }

    return (
        <div className="_7eya" onClick={() => setOpen(false)}>
            <div className="_9jcj" onClick={e => e.stopPropagation()}>
                <h2 className='new-customer-main-title'> New Customer</h2>
                <div className='app-new-tabs'>
                    <div className='new-customer-tabs'>
                        <div className="customer-type-buttons">
                            <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                <FormLabel component="legend">Customer Type</FormLabel>
                            </FormControl>
                            <RadioGroup className="customer-type-radio-btn" value={customerType} onChange={(e) => setCustomerType(e.target.value)} row aria-label="customer-type" name="customer-type">
                                <FormControlLabel value="business" control={<Radio />} label="Business" />
                                <FormControlLabel value="individual" control={<Radio />} label="Individual" />
                            </RadioGroup>
                        </div>
                        <div className="primary-contact">
                            <Box
                                component="form"
                                sx={{
                                    '& > :not(style)': { m: 1, width: '25ch' },
                                }}
                                noValidate
                                autoComplete="off"
                            />
                            <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                <FormLabel component="legend">Primary Contact</FormLabel>
                            </FormControl>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <div className="whingy-peep">
                                        <div className="peep-peep">
                                            <div
                                                onClick={() => setSalutationInputOpen(!salutationInputOpen)}
                                                className="salients-rap"
                                            >
                                                {selectedSalutation}
                                            </div>

                                            {salutationInputOpen ? (
                                                <div onClick={(e) => e.stopPropagation()} className="cirrus-tee">
                                                    {salutationOptions.map((option, index) => (
                                                        <button
                                                            key={index}
                                                            onClick={() => handleSalutationClick(option)}
                                                            className="term-button"
                                                        >
                                                            {option}
                                                        </button>
                                                    ))}
                                                </div>
                                            ) : undefined}
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={4}>
                                    <div className='primary-first-name'>
                                        <TextField onChange={(e) => setFirstName(e.target.value)} id="outlined-basic" label="First Name *" variant="outlined" />
                                    </div>
                                </Grid>
                                <Grid item xs={4}>
                                    <div className='primary-first-name'>
                                        <TextField onChange={(e) => setLastName(e.target.value)} id="outlined-basic" label="Last Name" variant="outlined" />
                                    </div>
                                </Grid>
                                {/* <input type="text" onChange={(e) => setFirstName(e.target.value)} name="FirstName" className="custom-input" placeholder="First Name" style={{ marginRight: '10px' }} />
                        <input type="text" onChange={(e) => setLastName(e.target.value)} name="LastName" className="custom-input" placeholder="Last Name" /> */}
                            </Grid>
                        </div>
                    </div>
                    <div className='company-details'>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <div className='company-details-list'>
                                    <TextField onChange={(e) => setCompanyName(e.target.value)} id="outlined-basic" label="Company Name" variant="outlined" />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className='company-details-list'>
                                    <TextField onChange={(e) => setEmail(e.target.value)} id="outlined-basic" label="Customer Email *" variant="outlined" />
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className='company-details-list'>
                                    <TextField onChange={(e) => setPhone(e.target.value)} id="outlined-basic" label="Phone Number" variant="outlined" />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    {/* </div> */}
                    {/* <div className="customer-type">
                    <FormControl component="div" style={{ width: '150px' }} margin="normal">
                        <FormLabel component="legend">Company Name</FormLabel>
                    </FormControl>
                    <input type="text" onChange={(e) => setCompanyName(e.target.value)} name="CompanyName" className="custom-input" placeholder="Company Name" />
                </div> */}
                    {/* <div className="customer-type">
                <FormControl component="div" style={{ width: '150px' }} margin="normal">
                    <FormLabel component="legend">Customer Name</FormLabel>
                </FormControl>
                <input type="text" name="CustomerName" className="custom-input" placeholder="Customer Name" />
            // </div> */}
                    {/* //     <div className="customer-type">
            //         <FormControl component="div" style={{ width: '150px' }} margin="normal">
            //             <FormLabel component="legend">Customer Email</FormLabel>
            //         </FormControl>
            //         <input type="text" onChange={(e) => setEmail(e.target.value)} name="CustomerEmail" className="custom-input" placeholder="Customer Email" />
            //     </div> */}
                    {/* <div className="customer-type">
                    <FormControl component="div" style={{ width: '150px' }} margin="normal">
                        <FormLabel component="legend">Customer Phone</FormLabel>
                    </FormControl>
                    <Box display="flex" alignItems="center">

                        <input type="text" onChange={(e) => setPhone(e.target.value)} name="PhoneNumber" className="custom-input" placeholder="Phone Number" />
                    </Box>
                </div> */}
                </div>
                <div className='other-address-remarks'>
                    <AppBar position="static" className="custom-appbar">
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            <Tab label="Other Details" />
                            <Tab label="Address" />
                            <Tab label="Custom Fields" />
                        </Tabs>
                    </AppBar>

                    {tabValue === 0 && (
                        <div>
                            <div className='pan-currency-content'>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <div className='company-details-list'>
                                            <TextField onChange={(e) => setPanCard(e.target.value)} id="outlined-basic" label="PAN" variant="outlined" />
                                        </div>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <div className='company-details-list'>
                                            <div className="whingy-peep">
                                                <div className="peep-peep">
                                                    <div
                                                        onClick={() => setCurrencyInputOpen(!currencyInputOpen)}
                                                        className="salients-rap"
                                                    >
                                                        {selectedCurrency && currencyOptions.find(option => option._id === selectedCurrency)?.name || 'Select Currency *'}
                                                    </div>
                                                    {currencyInputOpen ? (
                                                        <div onClick={(e) => e.stopPropagation()} className="cirrus-tee country-scroll">
                                                            <input
                                                                style={{ outline: "none" }}
                                                                placeholder="Search"
                                                                value={currencySearch}
                                                                onChange={e => setCurrencySearch(e.target.value)}
                                                            />
                                                            {currencyOptions.filter(item => item.name.toLowerCase().includes(currencySearch.toLowerCase()) || item.code.toLowerCase().includes(currencySearch.toLowerCase())).map((option, index) => (
                                                                <button
                                                                    key={index}
                                                                    onClick={() => handleCurrencyClick(option)}
                                                                    className="term-button"
                                                                >
                                                                    {option.code}- {option.name}
                                                                </button>

                                                            ))}
                                                        </div>
                                                    ) : undefined}
                                                </div>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} style={{ marginTop: "3px" }}>
                                    <Grid item xs={4}>
                                        <div className='company-details-list'>
                                            <TextField value={remarks} onChange={(e) => setRemarks(e.target.value)} id="outlined-basic" label="Remarks" variant="outlined" />
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    )}

                    {tabValue === 1 && (
                        <div className="ship-bill">
                            <div>
                                <h2 className='new-customer-main-title'>Billing Address</h2>
                                {/* <Typography variant="h6" gutterBottom>Billing Address</Typography> */}

                                <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
                                    <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                        <FormLabel component="legend">Country/Region</FormLabel>
                                    </FormControl>
                                    <select
                                        name="Country"
                                        className="custom-input states-countries"
                                        value={selectedCountry}
                                        onChange={e => setSelectedCountry(e.target.value)}
                                    >
                                        <option value="" disabled>
                                            Select a country
                                        </option>
                                        {countryOptions.map((country, index) => (
                                            <option key={index} value={country}>
                                                {country}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
                                    <FormControl component="div" style={{ width: '150px' }} margin="normal">
                                        <FormLabel component="legend">State</FormLabel>
                                    </FormControl>
                                    <select
                                        name="State"
                                        className="custom-input states-countries"
                                        value={selectedState}
                                        onChange={(e) => setSelectedState(e.target.value)}
                                    >
                                        <option value="" disabled>
                                            Select a state
                                        </option>
                                        {stateOptions.map((state, index) => (
                                            <option key={index} value={state}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='street'>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <div className='company-details-list'>
                                                <TextField onChange={(e) => setStreet(e.target.value)} id="outlined-basic" label="Street" variant="outlined" />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className='company-details-list'>
                                                <TextField onChange={(e) => setStreetOne(e.target.value)} id="outlined-basic" label="Street One" variant="outlined" />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className='street'>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <div className='company-details-list'>
                                                <TextField onChange={(e) => setCity(e.target.value)} id="outlined-basic" label="City" variant="outlined" />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className='company-details-list'>
                                                <TextField onChange={(e) => setZipcode(e.target.value)} id="outlined-basic" label="Zip Code" variant="outlined" />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>
                    )}

                    {tabValue === 2 && (
                        <div className="fishbolt-kaon">
                            {customFields.map((field, index) => {
                                return (
                                    <div className="parvo-pod" key={index}>
                                        <TextField
                                            sx={{ width: "400px" }}
                                            id="outlined-basic"
                                            label="Field Name"
                                            variant="outlined"
                                            value={field.fieldname}
                                            onChange={e => setCustomFields(prev => {
                                                const copy = JSON.parse(JSON.stringify(prev))
                                                copy[index].fieldname = e.target.value
                                                return copy
                                            })}
                                        />
                                        <TextField
                                            sx={{ width: "400px" }}
                                            id="outlined-basic"
                                            label="Field Value"
                                            variant="outlined"
                                            value={field.value}
                                            onChange={e => setCustomFields(prev => {
                                                const copy = JSON.parse(JSON.stringify(prev))
                                                copy[index].value = e.target.value
                                                return copy
                                            })}
                                        />
                                        {(customFields.length === index + 1) ? (
                                            <button onClick={() => {
                                                setCustomFields(prev => {
                                                    return [...prev, { fieldname: "", value: "" }]
                                                })
                                            }}>
                                                +
                                            </button>
                                        ) : (
                                            <button className="obtrudes-ref" onClick={() => {
                                                setCustomFields(prev => {
                                                    const copy = JSON.parse(JSON.stringify(prev))
                                                    copy.splice(index, 1)
                                                    return copy
                                                })
                                            }}>
                                                -
                                            </button>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
                <div className="footrot-pip">
                    <button className="ballroom-tab" onClick={handleSubmit}>
                        Save
                    </button>


                </div>
            </div>
        </div>
    )
}

export default AddNewCustomer
